import { prepareHeaders } from '@/lib/cookie'
import { BASE_URL } from '@/constant'
import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'

export interface GetTimesheetsParams {
  page: number
  limit: number
  search: string
  startDate: string
  endDate: string
  employee: string
  project: string
  billable?: boolean | string
  projecttype?: string
  sort_by?: string | undefined
  order?: 'ASC' | 'DESC' | undefined
}

export interface TimesheetEntry {
  task_id: number
  task_name: string
  list_id: number
  at: string
  project_name: string
  user_id: number
  user_email: string
  user_name: string
  billable: boolean
  tags: string
  duration_time: string
  start_time: string
  end_time: string
  duration_seconds: number
  description: string
  entry_id: string
  task_time_estimate_ms?: number | null
}

export interface TimesheetsResponse {
  data: TimesheetEntry[]
  pagination: {
    total: number
    totalPages: number
    currentPage: number
    limit: number
  }
}

export const timesheetApi = createApi({
  reducerPath: 'timesheetApi',
  baseQuery: fetchBaseQuery({
    baseUrl: `${BASE_URL}/employees`,
    prepareHeaders: prepareHeaders,
  }),
  tagTypes: ['Timesheets'],
  endpoints: builder => ({
    getTimesheets: builder.query<TimesheetsResponse, GetTimesheetsParams>({
      query: ({
        page,
        limit,
        search,
        startDate,
        endDate,
        employee,
        project,
        billable,
        projecttype,
        sort_by,
        order,
      }) => ({
        url: '/entries',
        params: {
          page,
          limit,
          search,
          startDate,
          endDate,
          employee,
          project,
          billable,
          projecttype,
          sort_by,
          order,
        },
      }),
      providesTags: ['Timesheets'],
    }),
  }),
})

export const { useGetTimesheetsQuery } = timesheetApi
